import Vue from 'vue'
import Vuex from 'vuex'
import {ignite} from 'vuex-ignite'
import {auth, db} from './firebase'

Vue.use(Vuex);

export const PUSH_MESSAGE = "PUSH_MESSAGE";
export const DISMISS_MESSAGE = "DISMISS_MESSAGE";

export default new Vuex.Store(ignite({
    state: {
        messages: [],
        messageCount: 0
    },
    mutations: {
        [PUSH_MESSAGE](state, message) {
            state.messages = [...state.messages, message];
            state.messageCount++;
        },
        [DISMISS_MESSAGE](state, messageId) {
            state.messages = state.messages.filter(message => message.id !== messageId);
        }
    },
    actions: {
        [PUSH_MESSAGE]({commit, state}, message) {
            const id = state.messageCount;
            message.id = id;
            commit(PUSH_MESSAGE, message);
            setTimeout(() => {
                commit(DISMISS_MESSAGE, id);
            }, 5000);
        }
    },
    firebase: {
        user: auth,
        projects: (user) => db.ref(`${user.uid}/content/projects`),
        meta: {
            ref: (user) => db.ref(`${user.uid}/content/meta`),
            type: Object
        },
        photos: (user) => db.ref(`${user.uid}/photos`)
    }
}))
